define('tavano_klaviyo_klaviyoordersource.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('tavano_klaviyo_klaviyoordersource', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div></div>";
},"useData":true}, 'extensions/Tavano/Klaviyo/3.1.5/', 'extensions/Tavano/Klaviyo/3.1.5/', Handlebars);
});